export default __webpack_public_path__ + "static/media/category_b.37ad29ff.svg";